import { Tag } from '../types';
import {api} from './api';

export const tagsApi = api.injectEndpoints({
	endpoints: (builder) => ({
		findGlobalTags: builder.query<Tag[], { excludeUnused?: boolean }>({
			query: (args) => ({
				url: 'tags/findGlobal',
				method: 'GET',
				params: args,
			}),
			providesTags: ['GlobalTags'],
		}),
	}),
});

export const { useFindGlobalTagsQuery } = tagsApi;
